<button class="go-back" (click)="location.back()" mat-raised-button>
  <mat-icon mat-list-icon>keyboard_backspace</mat-icon>
  Zurück
</button>

<mat-card *ngIf="userData && userData.user">
  <h2 class="mat-title">Nutzer: {{userData.user.name}}</h2>

  <mat-card-content>
    <table class="mat-table data-table">
      <tr>
        <th>Id</th>
        <td>{{userData.user.id}}</td>
      </tr>
      <tr>
        <th>Letze Anmeldung</th>
        <td>{{userData.user.lastLogin | date:'short'}}</td>
      </tr>
      <tr>
        <th>Letze Aktualisierung</th>
        <td>{{userData.user.upd | date:'short'}}</td>
      </tr>
      <tr>
        <th>Branche</th>
        <td>{{getSector()}}</td>
      </tr>
    </table>

    <button mat-raised-button
            #pwReset
            (click)="passwordChangeRequest(pwReset)"
            matTooltip="Anweisung zum Ändern des Passworts an Nutzer senden">
      Neues Passwort anfordern
      <mat-icon>vpn_key</mat-icon>
    </button>
    &nbsp;
    <button mat-raised-button matTooltip="Benutzeraktivitäten anzeigen" (click)="showHistory()">Benutzeraktivitäten
      <mat-icon>history</mat-icon>
    </button>

    <form class="user-form" [formGroup]="userDataForm">
      <mat-grid-list cols="6" formGroupName="user" rowHeight="100px">

        <mat-grid-tile colspan="3">
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Anrede</mat-label>
            <mat-select [(value)]="userData.user.salut" formControlName="salut">
              <mat-option>None</mat-option>
              <mat-option value="Herr">Herr</mat-option>
              <mat-option value="Frau">Frau</mat-option>
            </mat-select>
          </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile colspan="3">
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Vorname</mat-label>
            <input matInput formControlName="given_name">
          </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile colspan="3">
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>zweiter Vorname</mat-label>
            <input matInput formControlName="middle_name">
          </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile colspan="3">
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Nachname</mat-label>
            <input matInput formControlName="family_name">
          </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile colspan="3">
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Email</mat-label>
            <input matInput formControlName="email">
          </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile colspan="1">
          <mat-slide-toggle
            formControlName="valid"
            [checked]="userData.user.valid">
            Aktiv
          </mat-slide-toggle>
        </mat-grid-tile>

        <mat-grid-tile colspan="1">
          <mat-slide-toggle
            formControlName="email_verified"
            [checked]="userData.user.email_verified">
            E-Mail verifiziert
          </mat-slide-toggle>
        </mat-grid-tile>

        <mat-grid-tile colspan="1">
          <mat-slide-toggle
            formControlName="newsletterOptIn"
            [checked]="userData.user.newsletterOptIn">
            Newsletter
          </mat-slide-toggle>
        </mat-grid-tile>

      </mat-grid-list>
    </form>

  </mat-card-content>
  <mat-card-actions>
    <button (click)="saveUser()" mat-raised-button color="accent">Speichern
      <mat-icon>save</mat-icon>
    </button>
    <button (click)="location.back()" mat-raised-button>Abbrechen
      <mat-icon>cancel</mat-icon>
    </button>
    <!--    <button (click)="test()" mat-raised-button>Test</button>-->
  </mat-card-actions>
</mat-card>

<mat-card>
  <h2 class="mat-title">Gültige Zugänge</h2>

  <mat-card-content *ngIf="userData && userData.scopedClaims2user.length; else noClaims">
    <app-claim2user [claims2user]="userData.user.claims" [userData]="userData"></app-claim2user>
  </mat-card-content>
  <ng-template #noClaims>
    <p><strong>Der Benutzer hat keine Zugänge!</strong></p>
  </ng-template>

</mat-card>

<mat-card class="related-customers">
  <h2 class="mat-title">Zugehörige Kunden/ Organizationen</h2>

  <mat-card-content>
    <p>Organizationen finden</p>
    <form class="" [formGroup]="customerSearchForm">
      <mat-form-field class="w-300" appearance="outline">
        <mat-label>Eingabe</mat-label>
        <input
          (focusout)="hideSuggestions()"
          (keyup)="findCustomersLive()"
          matInput
          formControlName="input">
        <ng-container *ngIf="suggestions && customerSearchForm.value['column'] === 'name'">
          <ul class="search-suggestions">
            <li *ngFor="let s of suggestions" (click)="findRelatedCustomer(s.external_id)">{{s.name}}</li>
          </ul>
        </ng-container>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Spalte</mat-label>
        <mat-select formControlName="column">
          <mat-option value="external_id">Kdnr</mat-option>
          <mat-option value="name">Name</mat-option>
        </mat-select>
      </mat-form-field>

      <p>
        <button (click)="findRelatedCustomer()" mat-raised-button color="accent">Suchen
          <mat-icon>search</mat-icon>
        </button>
      </p>

    </form>

    <ng-container *ngIf="relatedCustomers">
      <p>Verfügbare Organisationen</p>
      <app-customers (customerAction)="customerAction($event)"
                     [claims2user]="userData.user.claims"
                     [relatedCustomers]="relatedCustomers"></app-customers>
    </ng-container>
  </mat-card-content>

</mat-card>

